import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, CardBody, Card, Table, } from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

//redux
import { values } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
import { setRequireCloseModal } from '../../../slices/personalProtectiveEquipment/reducer';
import { getEstablishmentList, getPersonList, } from '../../../helpers/establishment/backend_helper';
import { updatePersonalProtectiveEquipment, addNewPersonalProtectiveEquipment, getWarehouseItemList, reserveWarehouseItem, uploadFoldersFile, getPersonalProtectiveEquipmentByPersonId, getPersonalProtectiveEquipmentStatusByCode, sendNewEmailMessage, addNewBulkNotification, getUserByRoles, returnWarehouseItem, getPersonalProtectiveEquipmentList, updatePersonalProtectiveEquipmentDocument, } from '../../../slices/thunks';
import { getPersonalProtectiveEquipmentList as getPersonalProtectiveEquipmentListApi } from '../../../helpers/warehouse/backend_helper';
import OSelect from '../../../Components/OElements/OSelect';
import { getPersonalProtectiveEquipmentReasonList, getWarehouseList } from '../../../helpers/warehouse/backend_helper';
import SimpleBar from 'simplebar-react';
import useLogoLoader from '../../../Components/Hooks/useLogoLoaderHooks';
import useFileType from '../../../Components/Hooks/useFileTypeHooks';
import OInput from '../../../Components/OElements/OInput';
import { generateReturnPDF } from '../Document/PPEReturnDocument';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

import dayjs from "dayjs";
import { generatePDF } from '../Document/PPEDocument';

const PersonalProtectiveEquipmentReturn = ({ dataListSelect, isEdit, handleToggleReturnModal, isOpen, activeTab, toggleTab, onCleanSelection}) => {
	const dispatch = useDispatch();
	const { logoSrc } = useLogoLoader('login');
	const [folderPaths, setFolderPaths] = useState([]);
	const [selectedPPEList, setSelectedPPEList] = useState([]);
	const [dataListPerson, setDataListPerson] = useState([]);
	const [selectedEstablishment, setSelectedEstablishment] = useState(null);
	const [selectedReason, setSelectedReason] = useState(null);
	const [selectedCompany, setSelectedCompany] = useState(null);
	const [selectedWarehouse, setSelectedWarehouse] = useState(null);
	const [selectedPerson, setSelectedPerson] = useState(null);
	const [loading, setLoading] = useState(false);
	const [selectedReturnItems, setSelectedReturnItems] = useState({});


	const selectorPersonalProtectiveEquipment = createSelector(
		state => state.PersonalProtectiveEquipments,
		data => ({
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal,
			personalProtectiveEquipmentList: data.personalProtectiveEquipmentList,
			itemPersonalProtectiveEquipmentDetail: data.itemPersonalProtectiveEquipmentDetail,
		})
	);
	const { isAdding, isUpdating, isUpdated, isLoadingList, requireCloseModal, personalProtectiveEquipmentList, itemPersonalProtectiveEquipmentDetail } = useSelector(selectorPersonalProtectiveEquipment);

	const selectorItems = createSelector(
		state => state.WarehouseItems,
		data => ({
			dataList: data.warehouseItemList,
		})
	);
	const { dataList = [] } = useSelector(selectorItems);
	// const { file_type } = useFileType('EPPR');
	const {file_type} = useFileType('EPP');

	console.log('file_type_>??', file_type)


	useEffect(() => {
		dispatch(getPersonalProtectiveEquipmentStatusByCode('DVT'));
	}, []);

	const selectorUser = createSelector(
		state => state.Roles,
		result => ({
			users: result.itemUserRoleList,
		})
	);
	const { users } = useSelector(selectorUser);


	const [to, setTo] = useState([]);
	const [cc, setCC] = useState([]);

	useEffect(() => {
		const fetchDataTo = async () => {
			const roles = ['BDG'];
			const params = { roles: roles.join(',') };

			try {
				const response = await dispatch(getUserByRoles(params)).unwrap();
				setTo(response);
			} catch (error) {
				console.error('Error al obtener usuarios TO:', error);
			}
		};

		const fetchDataCc = async () => {
			const roles = ['SSO'];
			const params = { roles: roles.join(',') };

			try {
				const response = await dispatch(getUserByRoles(params)).unwrap();
				setCC(response);
			} catch (error) {
				console.error('Error al obtener usuarios CC:', error);
			}
		};

		fetchDataTo();
		fetchDataCc();
	}, [dispatch]);

	useEffect(() => {
		if(dataListSelect?.length){
			setSelectedPPEList(dataListSelect.map(item => item._id));
		}
	}, [dataListSelect])

	const uploadDocument = async (file, folderPaths, fileTypeId, establishmentId) => {
		if (!(file instanceof File)) {
			throw new Error("El archivo seleccionado no es válido.");
		}

		const formData = new FormData();
		formData.append("file", file);
		formData.append("file_type_id", fileTypeId);
		formData.append("establishment_id", establishmentId);

		folderPaths.forEach(path => formData.append("folder_paths", path));

		// console.log("FormData antes de la subida:");
		// for (let pair of formData.entries()) {
		// 	console.log(pair[0], pair[1]);
		// }

		try {
			const response = await dispatch(uploadFoldersFile(formData)).unwrap();
			return response;
		} catch (error) {
			console.error("Error uploading file:", error);
			throw error;
		}
	};

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			return_date: '',
			personal_protective_equipment_reason_id: '',
			reason: '',
		},
		validationSchema: Yup.object({
			personal_protective_equipment_reason_id: Yup.string().required('Campo requerido'),
			return_date: Yup.string().required('Campo requerido'),
		}),
		onSubmit: async values => {
			setLoading(true);
			
			const itemsToReturn = await buildReturnItemsPayload(selectedReturnItems);

			try {
						
				const response = await dispatch(
					returnWarehouseItem({
						items_to_return: itemsToReturn,
						establishment_id: values.establishment_id,
						person_id: values.person_id,
						return_date: values.return_date,
						personal_protective_equipment_reason_id: values.personal_protective_equipment_reason_id
					})
				).unwrap();

				const personalProtectiveEquipmentIds = Array.isArray(response)
					? response
						.filter(entry => Array.isArray(entry.items) && entry.items.length > 0)
						.map(entry => entry.personal_protective_equipment_id)
					: [];

					console.log('ids', personalProtectiveEquipmentIds);
				
				const ppe_updated_list = await getPersonalProtectiveEquipmentListApi({
					personal_protective_equipment_ids: personalProtectiveEquipmentIds
				})

				// Generate all PDFs PPE updated and upload all
				for (const ppe of ppe_updated_list) {

					const warehouseReturnPPE = response.find(
						item => item.personal_protective_equipment_id === ppe._id
					);

					const file = await generatePDF(
						logoSrc,
						{
							code: 'RG-RH-03',
							generation_date: '01-01-2025',
							modification_date: '01-01-2025',
							scope: 'Toda la Organización',
							status: 'Documento Controlado',
							version: '05',
							establishment: {
								name: ppe.establishment.name
							},
							person: {
								name: ppe.person.name,
								rut: ppe.person.rut
							},
							items: ppe.assigned_items
						}
					);

					let document = null;
					if (file) {
						const folder = '/' + ppe.establishment_type.name + '/' + (ppe.code_siep ? ppe.establishment.code_siep + ' - ' : '') + ppe.establishment.name + '/Abastecimiento/EPP/Entrega';
						const updatedFolderPaths = [...folderPaths, folder];
						setFolderPaths(updatedFolderPaths);

						try {
							// Subir documento de EPP actualizado luego de devolución
							const document_updated = await uploadDocument(file, updatedFolderPaths, file_type._id, values.establishment_id);

							// Actualizar documentación de EPP
							await dispatch(
								updatePersonalProtectiveEquipmentDocument({
									_id: ppe._id,
									document_id: document_updated[0]._id,
									warehouse_return_id: warehouseReturnPPE.warehouse_return_id 
								})
							).unwrap();
						} catch (error) {
							console.log('Error updated epp', error)
							return;
						}
					}
				}

			
				await onCleanSelection();
				await dispatch(getPersonalProtectiveEquipmentList())
				dispatch(setRequireCloseModal(true));
				handleToggleReturnModal();
			} catch (error) {
				console.log('error procesamiento', error)
				toast.error('Error al procesar la devolución');			
			}

			setLoading(false);
			
			// 

			// // Validar que haya al menos un ítem seleccionado
			// if (Object.keys(selectedItems).length === 0) {
			// 	toast.error('Debe seleccionar al menos un ítem para devolver.');
			// 	setLoading(false);
			// 	return; // Detener la ejecución si no hay ítems seleccionados
			// }

			// let warehouseId = null;

			// const assignedItems = Object.keys(selectedItems).map(itemId => {
			// 	const [warehouseItemId, code] = itemId.split('_');
			// 	const selected = selectedItems[itemId];

			// 	const item = dataListPerson.find(i => i.warehouse_item_id === warehouseItemId && i.code === selected.code);

			// 	if (!item) {
			// 		console.warn(`Item no encontrado para: ${itemId}`);
			// 		return null;
			// 	}

			// 	warehouseId = item.warehouse_id;
			// 	debugger;

			// 	return {
			// 		warehouse_id: item.warehouse_id,
			// 		warehouse_code: item.warehouse_code,
			// 		warehouse_group_id: item.warehouse_group_id,
			// 		warehouse_group_code: item.warehouse_group_code,
			// 		warehouse_item_id: item.warehouse_item_id,
			// 		warehouse_category_name: item.warehouse_category_name,
			// 		name: item.name || '',
			// 		description: item.description || '',
			// 		quantity: selected.quantity_returned || 1,
			// 		size: item.size || '',
			// 		color: item.color || '',
			// 		unit_measurement_name: item.unit_measurement_name,
			// 	};
			// }).filter(Boolean); // Filtra los null si algún item no se encontró 

			// // Crear el objeto final con la estructura solicitada
			// const formData = {
			// 	person_id: values.person_id,
			// 	cost_center: selectedPerson.cost_center?.code || null,
			// 	management_id: selectedPerson.management?._id || null,
			// 	establishment_id: values.establishment_id,
			// 	personal_protective_equipment_reason_id: values.personal_protective_equipment_reason_id,
			// 	reason: values.reason,
			// 	warehouse_id: warehouseId,
			// 	assigned_items: assignedItems,
			// 	return_date: values.return_date,
			// 	// delivery_date: values.delivery_date,
			// 	personal_protective_equipment_status_id: itemPersonalProtectiveEquipmentDetail?._id || null,
			// 	...(isEdit && { _id: dataPersonalProtectiveEquipment._id }),
			// };


			// try {
			// 	if (isEdit) {
			// 		await dispatch(updatePersonalProtectiveEquipment(formData));
			// 	} else {

			// 		const file = await generateReturnPDF(
			// 			dispatch,
			// 			logoSrc,
			// 			{
			// 				code: 'RG-RH-03',
			// 				generation_date: '01-01-2025',
			// 				modification_date: '01-01-2025',
			// 				scope: 'Toda la Organización',
			// 				status: 'Documento Controlado',
			// 				version: '05',
			// 				establishment: {
			// 					name: selectedEstablishment.name
			// 				},
			// 				person: {
			// 					name: selectedPerson.name,
			// 					rut: selectedPerson.rut
			// 				},
			// 				items: assignedItems
			// 			}
			// 		);

			// 		let documents = null;
			// 		if (file) {

			// 			const folder = '/' +
			// 				selectedEstablishment.establishment_type.name + '/' + (selectedEstablishment.code_siep ? selectedEstablishment.code_siep + ' - ' : '') + selectedEstablishment.name + '/Abastecimiento/EPP/Devolución';
			// 			const updatedFolderPaths = [...folderPaths, folder];
			// 			setFolderPaths(updatedFolderPaths);

			// 			try {
			// 				documents = await uploadDocument(file, updatedFolderPaths, file_type._id, values.establishment_id);
			// 			} catch (error) {
			// 				setIsDisabled(false);
			// 				return;
			// 			}
			// 			const document = documents[documents.length - 1];

			// 			if (document?._id) {
			// 				formData.document_id = document._id;
			// 			}

			// 			const ppe_items = updateSelectedItems();
			// 			const epp = await dispatch(addNewPersonalProtectiveEquipment(formData)).unwrap();

			// 			for (const item of ppe_items) {
			// 				if (item) {
			// 					await dispatch(updatePersonalProtectiveEquipment(item));
			// 				}
			// 			}

			// 			let subject = 'Devolución de EPP';

			// 			let body = `<div style="max-width: 600px; margin: auto; font-family: Arial, sans-serif; line-height: 1.6; color: #333; background-color: #f9f9f9; padding: 20px; border-radius: 8px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);">
															
			// 										<div style="text-align: center; margin-bottom: 20px;">
			// 												<h1 style="color: COLOR_SECONDARY;">Devolución de Elementos de Protección Personal</h1>
			// 										</div> 

			// 										<p style="text-align: justify;">
			// 											Informamos que al(la) trabajador(a), Sr(a) <b>${selectedPerson.name.toUpperCase()}</b>, ha realizado la devolución de Elementos de Protección Personal (EPP) bajo el código <b>${epp.code}</b>, con el objetivo de reitegrar estos elementos a badega para una nueva asignación. A continuación, se detallan los elementos por devolver.
			// 										</p>


										
			// 										<table style="width: 100%; border-collapse: collapse; margin-bottom: 20px; font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
			// 											<tr>
			// 												<th style="padding: 10px; border: 1px solid #ddd; text-align: center;">Elemento</th>
			// 												<th style="padding: 10px; border: 1px solid #ddd; text-align: center;">Cantidad</th>
			// 											</tr>
			// 											${assignedItems.map(item => `
			// 											<tr> 
			// 												<td style="padding: 10px; border: 1px solid #ddd;">${item.name}</td>
			// 												<td style="padding: 10px; border: 1px solid #ddd;">${item.quantity} ${item.unit_measurement_name}</td>
			// 											</tr>`).join('')}
			// 										</table>

			// 										<div style="margin-top: 30px; text-align: center; font-size: 0.8em;">
			// 												<p>Si tienes alguna pregunta o necesitas asistencia, por favor <a href="mailto:ayuda@openlink.cl" style="color: COLOR_SECONDARY;">contáctanos</a>.</p>
			// 												<p>Gracias. Equipo de Openlink.</p>
			// 										</div>
			// 								</div>`;


			// 			const date = new Date(epp.assignment_date);
			// 			let message =
			// 				'Devolución de EPP. Código: ' + epp.code +
			// 				' Nombre: ' + selectedPerson.name +
			// 				' Fecha Asignación: ' + date.toLocaleDateString();

			// 			if (to.length > 0) {
			// 				const uniqueEmailsTo = [...new Set(to.map(user => user.email))].join(',');
			// 				const uniqueEmailsCc = [...new Set(cc.map(user => user.email))].join(',');
			// 				const message_email = {
			// 					to_email: uniqueEmailsTo,
			// 					subject: subject,
			// 					body: body,
			// 					cc_email: uniqueEmailsCc
			// 				};
			// 				dispatch(sendNewEmailMessage(message_email));

			// 				const user_ids = [...new Set(to.map(user => user._id))];
			// 				const message_notification = {
			// 					title: subject,
			// 					message: message,
			// 					notification_priority_code: 'M',
			// 					notification_type_code: 'INF',
			// 					user_ids: user_ids
			// 				}
			// 				dispatch(addNewBulkNotification(message_notification));
			// 			}

			// 		}
			// 	}

			// 	setLoading(false);
			// 	dispatch(setRequireCloseModal(true));
			// 	handleToggleReturnModal();
			// } catch (err) {
			// 	console.error('Error al guardar:', err);
			// 	toast.error('Hubo un error al guardar la información');
			// }
		}

	});

	// Estado para filtros y selección
	const [selectedItems, setSelectedItems] = useState({});
	const [filteredDataList, setFilteredDataList] = useState(dataList);

	const [sizeFilter, setSizeFilter] = useState(null);
	const [categoryFilter, setCategoryFilter] = useState(null);
	const [phraseFilter, setPhraseFilter] = useState(null);

	const [sizeOptions, setSizeOptions] = useState([]);
	const [categoryOptions, setCategoryOptions] = useState([]);




	useEffect(() => {
		if (!dataList || dataList.length === 0) {
			setFilteredDataList([]);
			setSizeOptions([]);
			setCategoryOptions([]);
			setPhraseFilter(null);
			return;
		}

		setFilteredDataList(dataList);

		// Crear opciones para los selects
		const newSizeOptions = [...new Set(dataList.map(item => item.size).filter(Boolean))].map(size => ({
			label: size,
			value: size,
		}));

		const newCategoryOptions = [...new Set(dataList.map(item => item.warehouse_category?.name).filter(Boolean))].map(category => ({
			label: category,
			value: category,
		}));

		setSizeOptions(newSizeOptions);
		setCategoryOptions(newCategoryOptions);

	}, [dataList]);



	useEffect(() => {
		const filteredList = dataList.filter(item =>
			(!categoryFilter || item.warehouse_category?.name === categoryFilter) &&
			(!sizeFilter || item.size === sizeFilter) &&
			(!phraseFilter || item.name?.toLowerCase().includes(phraseFilter.toLowerCase()))
		);

		setFilteredDataList(filteredList);

	}, [categoryFilter, sizeFilter, phraseFilter]);



	useEffect(() => {
		setSelectedPerson(null);
		validation.setFieldValue('person_id', null);
		setSelectedCompany(selectedEstablishment ? selectedEstablishment.company_id : null);
	}, [selectedEstablishment]);




	useEffect(() => {
		if (selectedPerson) {
			dispatch(getPersonalProtectiveEquipmentByPersonId({ person_id: selectedPerson?._id, status_code_list: 'END,RTD', month: true }));
		}
	}, [selectedPerson]);



	useEffect(() => {
		if (personalProtectiveEquipmentList.length > 0 && selectedPerson) {

			const formattedData = personalProtectiveEquipmentList.flatMap((item) =>
				item.assigned_items
					// .filter(assignedItem => assignedItem.quantity_available > 0)
					.map((assignedItem) => ({
						personal_protective_equipment_status: item.personal_protective_equipment_status,

						color: assignedItem.color,
						description: assignedItem.description,
						name: assignedItem.name,
						size: assignedItem.size,
						unit_measurement_name: assignedItem.unit_measurement_name,
						warehouse_category_name: assignedItem.warehouse_category_name,
						warehouse_code: assignedItem.warehouse_code,
						warehouse_group_code: assignedItem.warehouse_group_code,
						warehouse_group_id: assignedItem.warehouse_group_id,
						warehouse_id: assignedItem.warehouse_id,
						warehouse_item_id: assignedItem.warehouse_item_id,
						code: item.code,
						delivery_date: item.delivery_date ?? null,
						establishment_name: item.establishment?.name ?? "Desconocido",
						quantity: assignedItem.quantity,
						quantity_returned: assignedItem.quantity_returned,
						quantity_available: assignedItem.quantity_available,

						warehouse: item.warehouse?.name ?? "No asignada",
					}))
			);

			setDataListPerson(formattedData);
		} else {
			setDataListPerson([]);
		}
	}, [personalProtectiveEquipmentList, selectedPerson]);


	// Cargar ítems al seleccionar bodega
	useEffect(() => {
		if (validation.values.warehouse_id) {
			dispatch(getWarehouseItemList({ warehouse_id: validation.values.warehouse_id, all: false }));
		}
		else {
			setFilteredDataList([])
		}
	}, [validation.values.warehouse_id]);



	function updateSelectedItems() {
		const updatedList = personalProtectiveEquipmentList.map((ppe) => {
			if (!Object.values(selectedItems).some(item => item.code === ppe.code)) {
				return null; // sin coincidencias
			}

			const updatedItems = ppe.assigned_items.map((assignedItem) => {
				const matchingEntry = Object.entries(selectedItems).find(
					([, selected]) =>
						selected.code === ppe.code &&
						selected.item.warehouse_item_id === assignedItem.warehouse_item_id
				);

				if (matchingEntry) {
					const [, selected] = matchingEntry;
					return {
						...assignedItem,
						quantity_returned: selected.quantity_returned,
						quantity_available: selected.quantity_available - selected.quantity_returned,
						returned: true,
					};
				}

				return assignedItem;
			});

			// Verificar si al menos un ítem fue modificado
			const anyModified = updatedItems.some(item => item.returned === true);

			if (anyModified) {
				return {
					...ppe,
					assigned_items: updatedItems,
				};
			}

			return null; // si nada fue modificado, descartar
		});

		// Filtrar los que no fueron modificados
		const filteredUpdatedList = updatedList.filter(Boolean);

		console.log('Solo modificados:', filteredUpdatedList);
		return filteredUpdatedList;
	}



	const columns = useMemo(
		() => [
			{ header: 'Ítem', accessorKey: 'name', size: 'auto' },
			{ header: 'Cantidad', accessorKey: 'quantity', size: 'auto' },
			{ header: 'Unidad', accessorKey: 'unit_measurement_name', size: 'auto' },
			{ header: 'Talla', accessorKey: 'size', size: 'auto' }, {
				header: 'Estado', accessorKey: 'personal_protective_equipment_status_name', size: 'auto',
				Cell: ({ row }) => {
					let status = row.original.personal_protective_equipment_status
					let bgColor = status?.bgcolor;
					let txColor = status?.txcolor;
					return (
						<div>
							<span className={`badge`} style={{ backgroundColor: bgColor, color: txColor }}>
								{status
									? status.name
									: ''}
							</span>
						</div>
					);
				},
			},
			{ header: 'code', accessorKey: 'code', size: 'auto' },
			{ header: 'Fecha de Entrega', accessorKey: 'delivery_date', dataType: 'datetime', size: 'auto' },
			{ header: 'Establecimiento', accessorKey: 'establishment_name', size: 'auto' },
		],
	);

	const transformedData = useMemo(() => {
		if (!dataListSelect) return [];

		const groupedItems = {};

		console.log(dataListSelect)

		dataListSelect.forEach(({ _id, assigned_items, code, ...ppeExtraData }) => {
			assigned_items.forEach(
				({
					warehouse_id,
					warehouse_item_id,
					name,
					quantity,
					unit_measurement_name,
					size,
					code_sap,
					quantity_available,
					quantity_returned
				}) => {
					// 👇 key compuesta incluyendo el code del ppe
					const key = `${name}-${size}-${unit_measurement_name}-${_id}`;

					if (!groupedItems[key]) {
						groupedItems[key] = {
							_id,
							warehouse_id,
							warehouse_item_id,
							code,
							name,
							unit_measurement_name,
							size,
							code_sap,
							quantity,
							quantity_available,
							quantity_returned,
							ppeExtraData
						};
					} else {
						groupedItems[key].quantity += quantity;
					}
				}
			);
		});

		return Object.values(groupedItems);
	}, [dataListSelect]);

	const formatDate = (dateStr) => {
		const date = new Date(dateStr);
		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const year = date.getFullYear();
		return `${day}-${month}-${year}`;
	};

	const buildReturnItemsPayload = async (selectedReturnItems) => {
		return Object.keys(selectedReturnItems).map((key) => {
			const { item, quantity_to_return } = selectedReturnItems[key];

			return {
				id: item._id,
				warehouse_id: item.warehouse_id,
				warehouse_item_id: item.warehouse_item_id,
				quantity_available: item.quantity_available,
				quantity: item.quantity,
				quantity_to_return: quantity_to_return
			};
		});
	};

	const handleRowSelectionChange = (keyId, payload) => {
		setSelectedReturnItems(prev => {
			const copy = { ...prev };

			if (!payload) {
			delete copy[keyId];
			} else {
			copy[keyId] = payload;
			}

			return copy;
		});
	};

	console.log('selectedReturnItems', selectedReturnItems)


	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col md={12} lg={3}>
								<DatesProvider settings={{ locale: 'es-mx', firstDayOfWeek: 1, weekendDays: [0], timezone: 'UTC' }}>
									<DatePickerInput
										label={
											<span>
												Fecha de Devolución <span style={{ color: 'red' }}>*</span>
											</span>
										}
										id='return_date'
										name='return_date'
										placeholder="Seleccione una fecha"
										value={
											validation.values.return_date
												? new Date(validation.values.return_date)
												: null
										}
										onChange={(date) => { validation.setFieldValue("return_date", date); }}
										onBlur={validation.handleBlur}
										valueFormat='DD-MM-YYYY'
										maxDate={new Date()}
										minDate={new Date(new Date().setDate(new Date().getDate() - 10))} // Set minDate to 5 days before today
										error={
											validation.touched['return_date'] && validation.errors['return_date']
												? validation.errors['return_date']
												: ''
										}
										clearable={true}
									/>
								</DatesProvider>
							</Col>

							<Col md={12} lg={6}>
								<OSelect
									key={'personal_protective_equipment_reason_id'}
									label='Motivo'
									id='personal_protective_equipment_reason_id'
									name='personal_protective_equipment_reason_id'
									isRequired={true}
									value={validation.values.personal_protective_equipment_reason_id || ''}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									onSelect={setSelectedReason}
									requestApi={() => getPersonalProtectiveEquipmentReasonList({ returnable: true })}
									validation={validation}
								/>
							</Col>
							<Col lg={9} hidden={selectedReason?.code != 'IA'}>
								<OInput
									name='reason'
									label='Detalle del motivo'
									type='text'
									placeholder='Ingrese un detalle del motivo'
									validation={validation}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
						</Row>
					</TabPane>

					<TabPane tabId='2'>
						{/* <Row>
							<Col lg={12}>
								<SimpleBar style={{ maxHeight: "300px" }}>
									<ODataGrid
										enableTopToolbar={false}
										columns={columns}
										data={transformedData}
										nameFile={'asignación_de_epp'}
									/>
								</SimpleBar>
							</Col>
						</Row> */}

						{transformedData?.length > 0 ? (
							<Row className="mt-3">
								<Col>
									<SimpleBar style={{ maxHeight: "300px" }} >
										<Table bordered hover striped  >
											<thead>
												<tr class="text-center align-middle">
													<th></th>
													<th>Devolución</th>
													<th>Disponible</th>
													<th>Devuelto</th>
													<th>Entregado</th>
													<th>Unidad</th>
													<th>Nombre</th>
													<th>Estado</th>
													<th>Código de Item</th>
													<th>Código Epp</th>
													<th>Fecha de Entrega</th>
													<th>Destino</th>
													<th>Persona</th>
												</tr>
											</thead>
											<tbody>
												{transformedData.map((item, index) => {
													const keyId = `${item.warehouse_item_id}_${item?.code_sap?.toUpperCase() || '-'}_${index}`;

													return (
													<PPEItemReturnRow
														key={keyId}
														keyId={keyId}
														item={item}
														onSelectionChange={handleRowSelectionChange}
													/>
													);
												})}
											</tbody>
										</Table>
									</SimpleBar>
								</Col>
							</Row>
						) : (
							<Row className="mt-3">
								<Col>
									<div className="text-center text-muted">
										Esta persona no cuenta con elementos de asignados o por entregar
									</div>
								</Col>
							</Row>
						)}



					</TabPane>
				</TabContent>
			</ModalBody >
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleReturnModal();
						}}
						className='btn-danger btn-label'
					>
						<i className='icon-x label-icon'></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={loading}
					>
						{loading ? (<i className='label-icon'><Spinner size='sm' /></i>) : (<i className='ri-save-3-line label-icon'></i>)}
						Devolver Equipamiento de Protección Personal
					</button>
				</div>
			</div>
		</Form >
	);
};

const PPEItemReturnRow = ({
	keyId, 
	item, 
	onSelectionChange 
}) => {
	const maxAvailable = item?.quantity_available;
	const [checked, setChecked] = useState(false);
	const [quantityReturn, setQuantityReturn] = useState(0);
	const isCheckDisabled = maxAvailable <= 0;
	
	const handleQuantityChange = (target, maxQuantityAvailable, newValue) => {
		const value = newValue === "" ? "" : parseInt(newValue, 10);

		if (newValue === "") {
			setQuantityReturn("");
			target.setCustomValidity(""); // limpiar error
			return;
		}

		if (isNaN(value) || value === 0) {
			setQuantityReturn("");
			target.setCustomValidity("El valor debe ser un número mayor que 0");
			target.reportValidity();
			return;
		}

		if (value > maxQuantityAvailable) {
			setQuantityReturn("");
			target.setCustomValidity(`El valor no puede superar la cantidad disponible (Máximo: ${maxQuantityAvailable})`);
			target.reportValidity();
			return;
		}

		// si pasa todas las validaciones
		setQuantityReturn(value);
		target.setCustomValidity(""); // limpiar error
	};

	const handleCheckChange = () => {
		const nextChecked = !checked;
		setChecked(nextChecked);

		if (nextChecked) {
			const qty = quantityReturn === "" ? maxAvailable : quantityReturn;
			setQuantityReturn(qty);
		} else {
			setQuantityReturn("");
		}
	};

	useEffect(() => {
		onSelectionChange(
			keyId,
			(
				quantityReturn !== 0 && quantityReturn !== ''
					? {
						item,
						quantity_to_return: quantityReturn
					}
					: null
			)
		);
	}, [quantityReturn])

	return (
		<tr key={keyId}>
			<td className="text-center align-middle">
				<Input
					className='p-2'
					type="checkbox"
					checked={checked}
					disabled={isCheckDisabled}
					onChange={() => handleCheckChange()}
				/>
			</td>

			<td className="text-center align-middle">
				<Input
					type="text"
					min="1"
					max={item.quantity_available}
					value={quantityReturn}
					disabled={!checked}
					onChange={
						(e) => 
							handleQuantityChange(
								e.target,
								maxAvailable,
								e.target.value
							)
					}
				/>
			</td>
			<td className="text-center align-middle">{item?.quantity_available}</td>
			<td className="text-center align-middle">{item?.quantity_returned}</td>
			<td className="text-center align-middle">{item?.quantity}</td>
			<td className="text-center align-middle">{item.unit_measurement_name.toUpperCase()}</td>
			<td className="text-center align-middle">{item.name.toUpperCase()}</td>
			<td className="text-center align-middle">
				<span
					className={`badge fs-11`}
					style={{
						backgroundColor: item.ppeExtraData.personal_protective_equipment_status.bgcolor,
						color: item.ppeExtraData.personal_protective_equipment_status.txcolor
					}}
				>
					{item.ppeExtraData?.personal_protective_equipment_status.name.toUpperCase()}
				</span>
			</td>
			<td className="text-center align-middle">{item?.code_sap?.toUpperCase() || '-'}</td>
			{/* <td>{formatDate(item.ppeExtraData.delivery_date)}</td> */}
			<td className="text-center align-middle">{item?.code?.toUpperCase() || '-'}</td>
			<td className="text-center align-middle">
				{
					dayjs(item.ppeExtraData.delivery_date || "").isValid() 
						? dayjs(item.ppeExtraData.delivery_date).format("DD-MM-YYYY")
						: ""
				}
			</td>
			<td className="text-center align-middle">{item.ppeExtraData?.establishment?.name?.toUpperCase() || '-'}</td>
			<td className="text-center align-middle">{item.ppeExtraData?.person?.name?.toUpperCase() || '-'}</td>
		</tr>

	);
}

export default PersonalProtectiveEquipmentReturn;
